import { graphql, useMutation, useQuery } from '@biscuits/graphql';
import { useCallback, useEffect } from 'react';
import { useIsLoggedIn } from './graphql.js';
import { useLocalStorage } from './useStorage.js';
const userPreference = graphql(`
	query UserPreference($key: String!) {
		me {
			id
			preference(key: $key) {
				id
				value
			}
		}
	}
`);
const setPreference = graphql(`
	mutation SetUserPreference($key: String!, $value: JSON!) {
		setUserPreference(input: { key: $key, value: $value }) {
			user {
				id
				preference(key: $key) {
					id
					value
				}
			}
		}
	}
`);
export function useUserPreference(key, defaultValue) {
    var _a, _b;
    const [localValue, setLocalValue] = useLocalStorage(`userPreference-${key}`, defaultValue, true);
    const isLoggedIn = useIsLoggedIn();
    const { data } = useQuery(userPreference, {
        variables: {
            key,
        },
        skip: !isLoggedIn,
    });
    const remoteValue = (_b = (_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.preference) === null || _b === void 0 ? void 0 : _b.value;
    useEffect(() => {
        if (remoteValue) {
            setLocalValue(remoteValue);
        }
    }, [remoteValue, setLocalValue]);
    const [setRemoteValue] = useMutation(setPreference);
    const setValue = useCallback(async (value) => {
        if (isLoggedIn) {
            await setRemoteValue({
                variables: {
                    key,
                    value,
                },
            });
        }
        setLocalValue(value);
    }, [isLoggedIn, setRemoteValue, setLocalValue, key]);
    return [remoteValue !== null && remoteValue !== void 0 ? remoteValue : localValue, setValue];
}
//# sourceMappingURL=useUserPreference.js.map